export function formatTanggalRange(input) {
    if (!input.includes('to')) return input;

    const [startRaw, endRaw] = input.split('to').map(s => s.trim());

    const start = new Date(startRaw);
    const end = new Date(endRaw);

    if (isNaN(start) || isNaN(end)) return input;

    const optionsTanggal = { day: 'numeric', month: 'long', year: 'numeric' };
    const optionsWaktu = { hour: '2-digit', minute: '2-digit', hour12: false };

    const tanggalStr = start.toLocaleDateString('id-ID', optionsTanggal);
    const jamMulai = start.toLocaleTimeString('id-ID', optionsWaktu);
    const jamSelesai = end.toLocaleTimeString('id-ID', optionsWaktu);

    return `${tanggalStr}, ${jamMulai} - ${jamSelesai}`;
}

// resources/js/helper/formatTanggal.js
export function tanggalIndo(dateStr) {
  return new Date(dateStr).toLocaleString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}